<template>
  <div v-if="!loading">
    <h1>
      <el-time-select
        size="small"
        class="select"
        style="width: 100px"
        :editable="false"
        :clearable="false"
        v-model="value1"
        @change="setTime"
        :picker-options="{
          start: '17:00',
          step: '00:15',
          end: '23:30',
        }"
        placeholder="选择下班时间"
      >
      </el-time-select>
      <p v-show="!expired" class="p">距离下班还有</p>
      <hgroup
        v-show="!expired"
        class="text-magic"
        :data-word="
          theTime.hours +
          '小时' +
          theTime.minutes +
          '分' +
          theTime.seconds +
          '秒'
        "
      >
        {{ theTime.hours || "00" }}小时{{ theTime.minutes || "00" }}分{{
          theTime.seconds || "00"
        }}秒
        <div class="white"></div>
      </hgroup>
      <!-- <h1>下班倒计时</h1>
		  <h1>{{theTime.hours}}小时{{theTime.minutes}}分{{theTime.seconds}}秒</h1> -->
    </h1>
    <hgroup v-if="expired" class="text-magic" :data-word="endText">
      {{ endText }}
      <div class="white"></div>
    </hgroup>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: ["loading"],
  data() {
    return {
      hours: "",
      minutes: "",
      seconds: "",
      endTime: "2018/06/05 19:00:00",
      endText: "我宣布：“下班走人！”",
      expired: false,
      value1: "18:00",
    };
  },
  computed: {
    theTime: function theTime() {
      var ctx = this,
        countDownDate = new Date(ctx.endTime).getTime();
      var x = setInterval(function () {
        var countDownDate = new Date(ctx.endTime).getTime(),
          now = new Date().getTime(),
          diff = countDownDate - now,
          tdays = Math.floor(diff / (1000 * 60 * 60 * 24)),
          thours = Math.floor(
            (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          tminutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
          tseconds = Math.floor((diff % (1000 * 60)) / 1000);
        ctx.days = tdays < 10 ? "0" + tdays : tdays;
        ctx.hours = thours < 10 ? "0" + thours : thours;
        ctx.minutes = tminutes < 10 ? "0" + tminutes : tminutes;
        ctx.seconds = tseconds < 10 ? "0" + tseconds : tseconds;
        if (diff < 0) {
          clearInterval(x);
          ctx.expired = true;
          document.title = `下班啦", "GO!GO!!GO!!!`;
          ctx.showNotice("下班啦", "GO!GO!!GO!!!");
        } else {
          document.title = `还有${ctx.hours}小时${ctx.minutes}分${ctx.seconds}秒下班`;
          ctx.expired = false;
        }
      }, 1000);
      return {
        days: ctx.days,
        hours: ctx.hours,
        minutes: ctx.minutes,
        seconds: ctx.seconds,
      };
    },
  },
  methods: {
    setTime: function setTime() {
      if (this.value1 === null) {
        this.value1 = localStorage.getItem("xbTime");
      } else {
        localStorage.setItem("xbTime", this.value1);
        this.endTime =
          new Date().getFullYear() +
          "/" +
          (new Date().getMonth() + 1) +
          "/" +
          new Date().getDate() +
          " " +
          this.value1;
      }
    },
    showNotice(title, msg) {
      var Notification =
        window.Notification ||
        window.mozNotification ||
        window.webkitNotification;
      if (Notification) {
        Notification.requestPermission(function (status) {
          //status默认值'default'等同于拒绝 'denied' 意味着用户不想要通知 'granted' 意味着用户同意启用通知
          if ("granted" != status) {
            return;
          } else {
            var tag = "sds" + Math.random();
            var notify = new Notification(title, {
              dir: "auto",
              lang: "zh-CN",
              tag: tag, //实例化的notification的id
              icon: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1528720538779&di=b70c57527816a37128f447118d96d723&imgtype=0&src=http%3A%2F%2Fn1.itc.cn%2Fimg8%2Fwb%2Frecom%2F2016%2F07%2F02%2F146742682457840687.GIF", //通知的缩略图,//icon 支持ico、png、jpg、jpeg格式
              body: msg, //通知的具体内容
            });
            (notify.onclick = function () {
              //如果通知消息被点击,通知窗口将被激活
              window.focus();
            }),
              (notify.onerror = function () {
                console.log("HTML5桌面消息出错！！！");
              });
            notify.onshow = function () {
              setTimeout(function () {
                notify.close();
              }, 2000);
            };
            notify.onclose = function () {
              console.log("HTML5桌面消息关闭！！！");
            };
          }
        });
      } else {
        console.log("您的浏览器不支持桌面消息");
      }
    },
  },
  beforeMount: function beforeMount() {
    if (
      localStorage.getItem("xbTime") &&
      localStorage.getItem("xbTime") != null
    ) {
      this.endTime =
        new Date().getFullYear() +
        "/" +
        (new Date().getMonth() + 1) +
        "/" +
        new Date().getDate() +
        " " +
        localStorage.getItem("xbTime");
      this.value1 = localStorage.getItem("xbTime");
    } else {
      if (this.value1 === null) {
        this.value1 = "18:00";
      }
      localStorage.setItem("xbTime", this.value1);
      this.endTime =
        new Date().getFullYear() +
        "/" +
        (new Date().getMonth() + 1) +
        "/" +
        new Date().getDate() +
        " " +
        this.value1;
    }
    console.log(` ██████╗  ██████╗    ██╗  ██╗ ██████╗ ███╗   ███╗███████╗
██╔════╝ ██╔═══██╗   ██║  ██║██╔═══██╗████╗ ████║██╔════╝
██║  ███╗██║   ██║   ███████║██║   ██║██╔████╔██║█████╗  
██║   ██║██║   ██║   ██╔══██║██║   ██║██║╚██╔╝██║██╔══╝  
╚██████╔╝╚██████╔╝▄█╗██║  ██║╚██████╔╝██║ ╚═╝ ██║███████╗
 ╚═════╝  ╚═════╝ ╚═╝╚═╝  ╚═╝ ╚═════╝ ╚═╝     ╚═╝╚══════╝`);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  white-space: nowrap;
}
h1 {
  /* text-align: center;
  align-items: center; */
  /* font-size: 8vw; */
  /* opacity: 0.2; */
}
.select {
  position: absolute;
  bottom: 10px;
  transform: translate3d(-50%, 0, 0);
}
.select >>> input {
  background: #000;
  border-color: #000;
}

.p{
  position: absolute;
  width: 100%;
  text-align: center;
  top:30%;
}
.text-magic {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0) skewX(0deg);
  /* font-size: 50px; */
  font-family: Raleway, Verdana, Arial, sans-serif;
  animation: skewX 5s ease-in infinite;
  white-space: nowrap;
}

@media (max-width: 375px) {
    /*0~320*/
    .text-magic {
        font-size: 10vw;
    }
}
.white {
  position: absolute;
  left: 0;
  top: 15px;
  width: 100%;
  height: 3px;
  background: #000;
  z-index: 4;
  animation: whiteMove 3s ease-out infinite;
  mix-blend-mode: luminosity;
}

.text-magic:before {
  content: attr(data-word);
  position: absolute;
  top: 0;
  left: 1px;
  height: 0px;
  color: rgba(255, 0, 0, 0.9);
  overflow: hidden;
  z-index: 2;
  animation: redShadow 1.5s ease-in infinite;
  -webkit-filter: contrast(200%);
  text-shadow: 0.1px 0 0 red;
  mix-blend-mode: color-burn;
}

.text-magic:after {
  content: attr(data-word);
  position: absolute;
  top: 0;
  left: -3px;
  height: 64px;
  color: rgba(255, 255, 255, 0.8);
  overflow: hidden;
  z-index: 3;
  animation: redHeight 2s ease-out infinite;
  -webkit-filter: contrast(200%);
  mix-blend-mode: hard-light;
}

@keyframes redShadow {
  20% {
    left: -1px;
    height: 32px;
  }
  60% {
    left: 2px;
    height: 6px;
  }
  100% {
    left: -2px;
    height: 42px;
  }
}

@keyframes redHeight {
  20% {
    height: 82px;
  }
  35% {
    height: 12px;
  }
  50% {
    height: 60px;
  }
  60% {
    height: 30px;
  }
  70% {
    height: 24px;
  }
  80% {
    height: 32px;
  }
  100% {
    height: 0px;
  }
}

@keyframes whiteMove {
  8% {
    top: 20px;
  }
  10% {
    top: 8px;
  }
  12% {
    top: 42px;
  }
  45% {
    top: 38px;
  }
  85% {
    top: 62px;
  }
  99% {
    top: 0px;
  }
}

@keyframes skewX {
  78% {
    transform: translate(-50%, -50%) skewX(0);
  }
  79% {
    transform: translate(-50%, -50%) skewX(10deg);
  }
  80% {
    transform: translate(-50%, -50%) skewX(-10deg);
  }
  81% {
    transform: translate(-50%, -50%) skewX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xbTime.vue